<script setup lang="ts">
import { computed } from 'vue'
import { SelectInput } from 'ui-kit'
import { useEnvironment } from '@/composables/useEnvironment'
import { SERVICES, type ServiceType } from '@/constants/environments'

const { currentService, setService } = useEnvironment()

const options = computed(() =>
  SERVICES.map((s) => ({
    value: s.key,
    text: s.label,
  })),
)

function onChange(value: string | number | undefined) {
  if (value && typeof value === 'string') {
    setService(value as ServiceType)
  }
}
</script>

<template>
  <div class="environment-selector">
    <SelectInput
      label=""
      :model-value="currentService.key"
      :options="options"
      @change="onChange"
    />
  </div>
</template>

<style scoped>
.environment-selector {
  min-width: 160px;
}
</style>
